import React from "react";

import SalesCoc from "../component/SalesCoc.jsx";
import NavbarComponent from "../component/NavbarComponent.jsx";

const SalesCocForm = () => (
  <div>
    <SalesCoc />
  </div>
);

export default SalesCocForm;
